// extracted by mini-css-extract-plugin
export default {"tr":"TableHead_tr__rMCPz","th":"TableHead_th__dLYMb"};